<!-- eslint-disable vue/multi-word-component-names -->

<template>
  <Environment name="STAGING">
    <slot></slot>
  </Environment>
</template>
